<script setup>
    /**
     * Vue Scripts
     */
    import {computed} from "vue";
    import {trialListingStore} from "@pinia/trial-listing-store";
    import {paginationApiSend, updateBrowserHistory} from "@util/api";

    /**
     * Vue Components
     */
    import Pagination from "@component/Pagination/Pagination.vue";
    import {toNumber} from "lodash";

    const {api, resultsDefault} = LISTING;
    const store = trialListingStore()

    const {perPage} = resultsDefault
    const {nextPage, previousPage} = resultsDefault?.pagination;

    const currentPage = computed(() => toNumber(store.query?.page || 1));
    const maxPages = computed(() => toNumber(store.resultsValues.maxPages || 1))
    const query = computed(() => store.query)
    const status = computed(() => store.status || '')
    const totalPages = computed(() => toNumber(store.resultsValues.total || 1))
    const goToElm = document.getElementById('filters-menu');

    /**
     * Refreshes the content based on what page was selected
     * @param page
     */
    const paginationClick = (page) => {
        store.$patch({
            resultsDefault: {
                ...resultsDefault,
                page,
            },
            showResults: store.resultsValues.posts[page - 1],
            query: {
                ...query.value,
                ppp: perPage || 5,
                page,
            },
        })

        const queryParams = {pages: page}
        status && (queryParams.status)

        updateBrowserHistory(queryParams)

        goToElm && goToElm.scrollIntoView({behavior: 'smooth'})
    }
</script>

<template>
    <div v-if="maxPages > 1"
         class="trials-footer">
        <Pagination
            :maxPages="totalPages"
            :nextPage="nextPage"
            :page="currentPage"
            :perPage="perPage"
            :prevPage="previousPage"
            @paginationHandler="paginationClick"
        />
    </div>
</template>

<script>
    export default {
        name: "Pagination"
    }
</script>

<style scoped lang="scss">

</style>
